import { StreamMessage } from 'stream-chat-react';
import { StreamChat, User } from 'stream-chat';
export const isErrorMessage = (message: StreamMessage) => message.type === 'error';

export const isDeletedMessage = (message: StreamMessage) => message.type === 'deleted';

export const isMessageReply = (message: StreamMessage) => message.type === 'reply';

export const isMessageFailed = (message: StreamMessage) => message.status === 'failed';

const isMessageShadowed = (message: StreamMessage) => message.shadowed === true;

export const isShadowMessageForOtherUser = (message: StreamMessage, user: User) => {
    return isMessageShadowed(message) && user.id !== message.user.id;
};

export const deleteMessage = (client: StreamChat, messageIdToDelete: string) =>
    client.deleteMessage(messageIdToDelete);

export const pinUnpinMessage = (client: StreamChat, message: StreamMessage) =>
    message.pinned ? client.unpinMessage(message) : client.pinMessage(message, null);
